export default __webpack_public_path__ + "static/media/wlogo.bd79051b.png";